export class StateInfo {
    constructor(public readonly state: string, public readonly count: number) {

    }

    public color;

    getColor = (): string => {
        switch (this.state) {
            case 'OLD':
                return '#808080';
            case 'MTS':
                return '#32CD32';
            case 'MTO':
                return '#FF0000';
            case 'OUT':
                return '0000FF';
        }

        return '#000000';
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/assortment-structure/state-info.ts